import React__default from 'react';
import { Text } from '@grandvisionhq/elements';
import { useIntl } from '@grandvisionhq/state';
import { roundNumber, formatPrice } from '@grandvisionhq/utils';
import { CartDiscountType } from '../../../types/index.js';

const PriceAside = ({ item , currency  })=>{
    const { locale , getFormattedLabel  } = useIntl();
    if (item.type === CartDiscountType.PERCENT) {
        const percentage = roundNumber(item.amount, 0);
        return /*#__PURE__*/ React__default.createElement(Text, {
            color: "primary",
            variant: "caption-head"
        }, getFormattedLabel('products.contactLenses.quantityDiscountSelect.save.percentage', {
            labelData: {
                percentage
            }
        }));
    }
    const amount = formatPrice({
        locale,
        value: item.amount,
        currency,
        isCentAmount: false
    });
    return /*#__PURE__*/ React__default.createElement(Text, {
        color: "primary",
        variant: "caption-head"
    }, getFormattedLabel('products.contactLenses.quantityDiscountSelect.save.amount', {
        labelData: {
            amount
        }
    }));
};

export { PriceAside };
//# sourceMappingURL=PriceAside.js.map
